export default "__VITE_ASSET__sGVdxHiQ__"